import { render } from "./riskPic.vue?vue&type=template&id=69d33b2f&scoped=true"
import script from "./riskPic.vue?vue&type=script&lang=js"
export * from "./riskPic.vue?vue&type=script&lang=js"

import "./riskPic.vue?vue&type=style&index=0&id=69d33b2f&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69d33b2f"]])

export default __exports__